import type { ToolFilterCondition } from '@troia-v3/types';

/**
 * Operadores disponíveis para filtros de ferramentas
 */
export interface OperatorOption {
  value: string;
  label: string;
}

export const OPERATORS: OperatorOption[] = [
  { value: 'equals', label: 'Igual' },
  { value: 'not_equals', label: 'Diferente' },
  { value: 'contains', label: 'Contém' },
  { value: 'not_contains', label: 'Não contém' },
  { value: 'starts_with', label: 'Começa com' },
  { value: 'ends_with', label: 'Termina com' },
  { value: 'greater_than', label: 'Maior que' },
  { value: 'less_than', label: 'Menor que' },
  { value: 'is_empty', label: 'Está vazio' },
  { value: 'is_not_empty', label: 'Não está vazio' },
];

/**
 * Operadores que não precisam de valor (campo de valor fica oculto)
 */
export const OPERATORS_WITHOUT_VALUE = ['is_empty', 'is_not_empty'];

/**
 * Campos disponíveis organizados por categoria
 */
export interface FieldOption {
  value: string;
  label: string;
  category: string;
}

/**
 * Valor sentinela do select de campo que revela o input de caminho JSON.
 * O valor persistido em `filter.field` é sempre o caminho real (`$.a.b`).
 */
export const JSON_FIELD_SENTINEL = '__json__';

export function isJsonPathField(field: string): boolean {
  return field === '$' || field.startsWith('$.');
}

export const FIELD_OPTIONS: FieldOption[] = [
  // Contato
  { value: 'contact.name', label: 'Nome', category: 'Contato' },
  { value: 'contact.phone', label: 'Telefone', category: 'Contato' },
  { value: 'contact.email', label: 'E-mail', category: 'Contato' },
  { value: 'contact.tags', label: 'Tags', category: 'Contato' },

  // Conversa
  { value: 'conversation.status', label: 'Status', category: 'Conversa' },
  { value: 'conversation.channelId', label: 'Canal', category: 'Conversa' },
  { value: 'conversation.assigneeId', label: 'Atendente', category: 'Conversa' },

  // Lead
  { value: 'lead.status', label: 'Status', category: 'Lead' },
  { value: 'lead.stage', label: 'Etapa', category: 'Lead' },

  // Retorno da requisição — filtros $.caminho avaliados APÓS a requisição da
  // ferramenta, contra o JSON retornado (2026-07-02). Reprovou => resultado
  // neutro pro agente e pula o processamento com IA.
  { value: JSON_FIELD_SENTINEL, label: 'Campo do JSON (personalizado)', category: 'Retorno da requisição' },
];

/**
 * Agrupa campos por categoria para exibição em optgroups
 */
export function getFieldsByCategory(): Record<string, FieldOption[]> {
  const grouped: Record<string, FieldOption[]> = {};
  for (const field of FIELD_OPTIONS) {
    if (!grouped[field.category]) {
      grouped[field.category] = [];
    }
    grouped[field.category].push(field);
  }
  return grouped;
}

/**
 * Cria um filtro vazio
 */
export function createEmptyFilter(): ToolFilterCondition {
  return {
    field: '',
    operator: 'equals',
    value: '',
  };
}
